import { reactive } from "vue";

const theme = reactive({
  agentLogo: "",
  devLogo: "logo.png",
  apiUrl: "https://api.metaluxe.com.au/",
  bunnyApiUrl: "https://api.bunny.net/",

  videoLibraryId: "370382",
  streamCdnUrl: "https://vz-2c540b8e-cad.b-cdn.net",
  streamApiKey: "ac70a81c-259b-4422-9a4c3a3acd94-918e-4077",

  storageApiPassword: "11e743b2-0d3a-40b8-935b32782f49-a494-4603",
  cdnUrl: "https://71-Garfield.b-cdn.net",
  devFolder: "/71-garfield",

  videosIcon: "/img/ui-theme/videos-icon.svg",
  rendersIcon: "/img/ui-theme/renders-icon.svg",
  rangeIcon: "/img/ui-theme/range-icon.svg",
  panoramasIcon: "/img/ui-theme/panoramas-icon.svg",
  floorplansIcon: "/img/ui-theme/floorplans-icon.svg",
  dashboardMp4: "theme/dashboard/4K_dashboard.mp4",

  // top level menu
  assetsMenuOrder: [
    "three-bed-villas",
    "four-bed-villas-Type-A",
    "four-bed-villas-type-B",
    "recreation-centre",
  ],
  menuOrder: ["Type-A", "Type-B", "Type-C", "Type-D"],
  typeCMenuOrder: ["videos", "360-tour", "balcony-views", "renders"],
  typeBMenuOrder: ["videos", "360-tour", "balcony-views", "renders"],
  typeAMenuOrder: ["videos", "360-tour", "balcony-views", "renders"],
  typeAMenuOrder: ["videos", "360-tour", "balcony-views", "renders"],

  typeAAsset: {
    videos: [],
    videosName: [],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
    panoramas: [0],
    panoramasName: [""],
    panoramasUrl: ["https://storage.net-fs.com/hosting/7566552/27/"],
    balconyViews: [0],
    balconyViewsUrl: ["https://storage.net-fs.com/hosting/7566552/35/"],
    balconyViewsName: [""],
    renders: [],
  },
  typeCAsset: {
    videos: [],
    videosName: [],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
    panoramas: [0],
    panoramasName: [""],
    panoramasUrl: ["https://storage.net-fs.com/hosting/7566552/37/"],
    balconyViews: [0],
    balconyViewsUrl: [""],
    balconyViewsName: [""],
    renders: [],
  },
  typeBAsset: {
    videos: [],
    videosName: [],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
    panoramas: [0],
    panoramasName: [""],
    panoramasUrl: ["https://storage.net-fs.com/hosting/7566552/39/"],
    balconyViews: [0],
    balconyViewsUrl: ["https://storage.net-fs.com/hosting/7566552/38/"],
    balconyViewsName: [""],
    renders: [],
  },

  typeDAsset: {
    videos: [],
    videosName: [],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
    panoramas: [0],
    panoramasName: [""],
    panoramasUrl: ["https://storage.net-fs.com/hosting/7566552/42/"],
    balconyViews: [0],
    balconyViewsUrl: ["https://storage.net-fs.com/hosting/7566552/41/"],
    balconyViewsName: [""],
    renders: [],
  },
});

export default { theme };
